/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019-2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * AngularJs component that displays list of unsplash photo to import into Bulb.
 */
angular.module('bulbApp.assetLibraryModule')
  .component('bulbAssetLibraryUnsplash', {
    templateUrl: 'ajs/assetlibrary/unsplash/assetlibrary-unsplash.html',
    controllerAs: 'unsplashCtrl',
    controller: ['$translate', 'BulbAssetLibraryUnsplashService', 'BulbBusyCoverService', AssetLibraryUnsplashController],
  });

function AssetLibraryUnsplashController($translate, BulbAssetLibraryUnsplashService, BulbBusyCoverService) {
  const that = this;
  this.query;
  this.imageList = [];
  this.page = 1;
  this.message = '';
  this.resultString = '';
  this.totalPages = 0;

  /**
    * Search unsplash photo for every new query
    */
  this.newSearch = function () {
    that.clearSearchResults(false);
    that.search();
  };

  /**
     * Method to search photo using query.
     */
  this.search = function () {
    that.message = '';
    if (that.query === '') return;
    BulbBusyCoverService.showBusyDuring(
      BulbAssetLibraryUnsplashService.searchPhoto(that.query, that.page)
        .then((result) => {
          that.isSearching = false;
          that.imageList = that.imageList.concat(result.results);
          if (!that.imageList || that.imageList.length === 0) {
            that.message = $translate.instant('assetlibrary_unsplash_no_photos_found');
            that.resultString = '';
          } else {
            that.message = '';
            that.resultString = result.total + $translate.instant('assetlibrary_search_images_result');
            that.totalPages = result.total_pages;
          }
        }),
    );
  };

  /**
     * Clear the search results and reset all variables.
     * @param clearQuery - boolean to decide whether to clear query
     */
  this.clearSearchResults = function (clearQuery) {
    if (clearQuery === true) {
      that.query = '';
    }
    that.message = '';
    that.imageList = [];
    that.page = 1;
    that.resultString = '';
    that.totalPages = 0;
  };

  /**
     * Called when photo is selected from picker.
     * @param photoId - Unique id for photo.
     */
  this.selectPhoto = function (photoId) {
    BulbAssetLibraryUnsplashService.selectPhoto(photoId);
  };

  /**
     * handle the pagination.
     * @param actionType type of action - 'prev' or 'next'.
     */
  this.handlePagination = function (actionType) {
    if (actionType === 'next') {
      if (that.page == that.totalPages) {
        return;
      }
      that.page++;
    }
    that.search();
  };
}
